<template lang="pug">
validation-observer(ref='validation')
  .container-cadastro
    .card-header Resumo
    pecaTecnica(
      v-if="!loading"
      :cadastroColetivo="cadastroColetivo"
      :isResumo="true"
      @validacaoDocumentos="documentos"
    )
    div.load(v-else)
      h4 Aguarde a geração de peças técnicas.
      img.relogio(src="@/assets/images/relogio.gif", alt="alt" style)
</template>

<script>
import AppNotificacao from '@/components/mixins/AppNotificacao'
import ValidacaoEdicaoCadastro from '@/screens/arrecadacao/components/ValidacaoEdicaoCadastro'
import BaseAnaliseProcessos from '@/screens/arrecadacao/mixins/BaseAnaliseProcessos'
import PecaTecnica from '@/screens/arrecadacao/gat/components/PecaTecnica'
import { mapActions } from 'vuex'

const { router } = require('@/utils/' + process.env.ESTADO + '/regrasArrecadacao').default

export default {
  components: {
    ValidacaoEdicaoCadastro,
    PecaTecnica
  },

  props: {
    cadastroColetivo: {
      type: Object,
      required: true
    }
  },

  mixins: [AppNotificacao, BaseAnaliseProcessos],

  data () {
    return {
      documentos: [],
      loading: true,
      fila: null,
      intervalFila: null,
      isDataCadastroAtualizado: false
    }
  },

  async created () {
    // await this.init()
  },

  mounted () {
    this.jobBuscarFila()
  },

  beforeDestroy () {
    clearInterval(this.intervalFila)
  },

  methods: {
    ...mapActions({
      findByIdCadastroColetivo: 'cadastroColetivo/findById',
      getFilaByIdProcesso: 'filaPlantaMemorial/getFilaByIdProcesso'
    }),

    validacaoDocumentos (documentos) {
      this.cadastroColetivo.pecaTecnica.dadoPecaTecnica.documentos = documentos
    },

    jobBuscarFila () {
      this.intervalFila = setInterval(() => {
        this.buscarFila()
      }, 5000)
    },

    async buscarFila () {
      try {
        const fila = await this.getFilaByIdProcesso(this.cadastroColetivo.processoArrecadacao.id)
        this.fila = fila
      } catch (error) {
        let message = error.message

        this.showNotificacao(
          this.$messages.TIPO_ERROR,
          this.$messages.TITULO_ERROR,
          message
        )
      }
    },
    async buscarCadastroAtualizado () {
      try {
        this.isDataCadastroAtualizado = await this.findByIdCadastroColetivo(this.cadastroColetivo.id)

        const currentRoute = this.$route
        const rotaResumo = (currentRoute.query.isResumo === 'true')
        const rotaAnterior = window.location.href.includes('arrecadacao/gat/cadastroColetivo/pecaTecnica') && !window.location.href.includes('?')

        if (!rotaResumo && rotaAnterior) {
          this.$router.push({
            name: router.RESUMO,
            query: {
              idCadastroColetivo: this.cadastroColetivo.id,
              isResumo: true
            }
          })
          this.isDataCadastroAtualizado = true
          if (this.isDataCadastroAtualizado) {
            setTimeout(() => {
              window.location.reload()
            }, 500)
          }
        }
      } catch (error) {
        let message = error.message
        this.showNotificacao(
          this.$messages.TIPO_ERROR,
          this.$messages.TITULO_ERROR,
          message
        )
      }
    }
  },

  watch: {
    cadastroColetivo: {
      handler () {
        if (this.cadastroColetivo.processoArrecadacao && this.cadastroColetivo.processoArrecadacao.id) {
          this.buscarFila()
        }
      },
      deep: true,
      immediate: true
    },

    fila: {
      async handler (val) {
        if (val && val.status && val.statusGeracaoMapas) {
          if (val.status === 'ANALISADO' && val.statusGeracaoMapas === 'ANALISADO') {
            clearInterval(this.intervalFila)
            await this.buscarCadastroAtualizado()
            this.loading = false
            this.$emit('exibirBotaoFinalizar')
          }
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.container-cadastro {
  display: flex;
  height: 100%;
  flex-direction: column;
}
.relogio {
  width: 100px;
  margin-bottom: 10px;
}
.load {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}

</style>



// WEBPACK FOOTER //
// src/screens/arrecadacao/gat/components/ResumoPecasTecnicas.vue